import React from 'react';
import classnames from 'classnames';
import { pitchOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const Pitch = (props) => {
  const name = 'pitch';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('silkscreen-sides', className)}
      disabled={disabled} />
  );
};

Pitch.defaultProps = {
  label: Spree.translations.parameters.pitch,
  options: pitchOptions,
  name: 'pitch',
  tooltip: Spree.helpForParameters.pitch,
};

export default Pitch;
